(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function revealAll(items) {
    items.forEach(function (item) {
      item.classList.add('is-visible');
    });
  }

  function initSection(section) {
    var items = Array.prototype.slice.call(
      section.querySelectorAll(
        '.ted-parents-trust__eyebrow, .ted-parents-trust__point, .ted-parents-trust__description, .ted-parents-trust__media'
      )
    );
    if (!items.length) return;

    if (prefersReducedMotion()) {
      revealAll(items);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.15,
      }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function init() {
    document.querySelectorAll('.ted-parents-trust').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
